export default __webpack_public_path__ + "static/media/closenew.575b5415.svg";